// extracted by mini-css-extract-plugin
export default {"besiness_consulting":"Consulting_besiness_consulting__vWryT","business_service_process":"Consulting_business_service_process__QmqwM","service":"Consulting_service__Rhycj"};